import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

interface SettingsNavButtonProps {
  isActive: boolean
  onClick: () => void
  children: React.ReactNode
}

export function SettingsNavButton({ isActive, onClick, children }: SettingsNavButtonProps) {
  return (
    <Button
      variant="ghost"
      onClick={onClick}
      className={cn(
        "justify-start transition-colors",
        "lg:w-full",
        "flex-shrink-0 whitespace-nowrap",
        isActive &&
          "text-primary-600 bg-gray-100 hover:bg-gray-100 dark:bg-accent dark:text-accent-foreground dark:hover:bg-accent"
      )}
    >
      {children}
    </Button>
  )
}
